<div class="ihsm-dropdown-main filter LegendTextPositionTop">  <!-- add variable for the position of the label -->
  <div *ngIf="data && data.caption" class="labelWrapper">
    <div *ngIf="data && data.caption" class="ihsm-dropdown-label legendText" [ngClass]="{'disable' : disabled}">
      <p>{{data.caption}}</p>
    </div>
    <div *ngIf="data && data.postCount !== null && data.postCount !== undefined" class="count"
    [ngClass]="selectedItemMulti.length > 0 ? 'applied' : ''">{{formatNumber(data.postCount)}}</div>
  </div>
  <div class="ihsm-dropdown-blank" (click)="toggleDropdown()" [ngClass]="{'active': toggle, 'disable' : disabled}"
       *ngIf="showDropdown && dropdownType === 'single'">
    <div class="ihsm-dropdown-icon">
      <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="chevron-down"
           class="svg-inline--fa fa-chevron-down fa-w-14" role="img" xmlns="http://www.w3.org/2000/svg"
           viewBox="0 0 448 512">
        <path fill="currentColor"
              d="M207.029 381.476L12.686 187.132c-9.373-9.373-9.373-24.569 0-33.941l22.667-22.667c9.357-9.357 24.522-9.375 33.901-.04L224 284.505l154.745-154.021c9.379-9.335 24.544-9.317 33.901.04l22.667 22.667c9.373 9.373 9.373 24.569 0 33.941L240.971 381.476c-9.373 9.372-24.569 9.372-33.942 0z"></path>
      </svg>
    </div>
    <p class="ihsm-selected-item-label" *ngIf="!selectedItem || !selectedItem.value">{{label}}</p>
    <p class="ihsm-selected-item-label" *ngIf="selectedItem" [ngClass]="{'ihsm-selectedItem' : selectedItem.value}">
      {{selectedItem.label}}</p>
    <div class="ihsm-dropdown-links" *ngIf="toggle" [ngClass]="{'active': toggle}">
      <div *ngIf="enableSearch" class="dropdown-search-container" id="searchInputContainer"
           (click)="searchContainerSelected($event)">
        <input id="searchInputField" type="text" class="ihsm-dropdown-searchbox dropdown-search remain-open" [ngModel]="searchValue"
               placeholder="Search" (ngModelChange)="searchValueChange($event)" (focus)="showList"
               #vdGroupInput />
      </div>
      <ul>
        <li *ngFor="let option of data?.options" (click)="selectItem(option)">
          <div class="checkmark-holder">
            <span class="ihsm-checkbox-tick" *ngIf="option.selected">
              <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="check"
                   class="svg-inline--fa fa-check fa-w-16" role="img" xmlns="http://www.w3.org/2000/svg"
                   viewBox="0 0 512 512"><path fill="currentColor"
                     d="M173.898 439.404l-166.4-166.4c-9.997-9.997-9.997-26.206 0-36.204l36.203-36.204c9.997-9.998 26.207-9.998 36.204 0L192 312.69 432.095 72.596c9.997-9.997 26.207-9.997 36.204 0l36.203 36.204c9.997 9.997 9.997 26.206 0 36.204l-294.4 294.401c-9.998 9.997-26.207 9.997-36.204-.001z"></path></svg>
            </span>
          </div>
          <p class="label-holder" [ngbTooltip]="option.label" [ngClass]="{'active-label': option.selected}">{{option.label}}</p>
        <li>
      </ul>
    </div>
  </div>

  <div class="ihsm-dropdown-blank" (click)="toggleDropdown()" [ngClass]="{'active': toggle, 'disable' : disabled}"
       *ngIf="dropdownType === 'multi'">
    <div class="ihsm-dropdown-icon">
      <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="chevron-down"
           class="svg-inline--fa fa-chevron-down fa-w-14" role="img" xmlns="http://www.w3.org/2000/svg"
           viewBox="0 0 448 512">
        <path fill="currentColor"
              d="M207.029 381.476L12.686 187.132c-9.373-9.373-9.373-24.569 0-33.941l22.667-22.667c9.357-9.357 24.522-9.375 33.901-.04L224 284.505l154.745-154.021c9.379-9.335 24.544-9.317 33.901.04l22.667 22.667c9.373 9.373 9.373 24.569 0 33.941L240.971 381.476c-9.373 9.372-24.569 9.372-33.942 0z"></path>
      </svg>
    </div>
    <p class="ihsm-selected-item-label" *ngIf="selectedItemMultiReadOnly"
       [ngClass]="{'ihsm-selectedItem' : selectedItemMultiReadOnly}"
       [title]="selectedItemMultiReadOnly">
      {{selectedItemMultiReadOnly}}</p>
    <p class="ihsm-selected-item-label" *ngIf="!selectedItemMultiReadOnly">
      Select Item</p>
    <div class="ihsm-dropdown-links" *ngIf="toggle" [ngClass]="{'active': toggle}">

      <div class="ihsm-dropdown-multi header" *ngIf="data && !data.customAllOption && maxItemsToChoose === data.options.length" (click)="toggleSelectAllOptions($event)">
        <div class="checkbox-holder">
          <div class="checkbox">
            <input type="checkbox">
            <span class="ihsm-checkbox-minus" *ngIf="selectedItemMultiReadOnly">
              <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="minus"
                   class="svg-inline--fa fa-minus fa-w-14" role="img" xmlns="http://www.w3.org/2000/svg"
                   viewBox="0 0 448 512"><path fill="currentColor"
                                               d="M416 208H32c-17.67 0-32 14.33-32 32v32c0 17.67 14.33 32 32 32h384c17.67 0 32-14.33 32-32v-32c0-17.67-14.33-32-32-32z"></path></svg>
            </span>
            <span class="checkmark" [ngClass]="{'ihsm-multi-option-selected' : selectedItemMultiReadOnly}"></span>
          </div>
        </div>

        <p class="ihsm-select-all ihsm-display-inline">{{this.data && this.data.customAllOptionsText ? this.data.customAllOptionsText : 'All'}}</p>
      </div>
      <div class="ihsm-dropdown-separator" *ngIf="data && !data.customAllOption"></div>
      <div *ngIf="enableSearch" class="dropdown-search-container" id="searchInputContainerMulti"
           (click)="searchContainerSelected($event)">
        <input id="searchInputFieldMulti" type="text" class="ihsm-dropdown-searchbox dropdown-search remain-open" [(ngModel)]="searchValue"
               placeholder="Search" (ngModelChange)="searchValueChange($event)" (focus)="showList"
               #vdGroupInput />
      </div>
      <ul>
        <li class="ihsm-multi-links" *ngIf="data && data.customAllOption" (click)="toggleDeselectAllOptions($event)">
          <div class="checkbox-holder">
            <div class="checkbox">
              <input type="checkbox">
              <span class="ihsm-checkbox-tick" *ngIf="selectedItemMulti.length === 0">
                <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="check"
                     class="svg-inline--fa fa-check fa-w-16" role="img" xmlns="http://www.w3.org/2000/svg"
                     viewBox="0 0 512 512"><path fill="currentColor"
                                                 d="M173.898 439.404l-166.4-166.4c-9.997-9.997-9.997-26.206 0-36.204l36.203-36.204c9.997-9.998 26.207-9.998 36.204 0L192 312.69 432.095 72.596c9.997-9.997 26.207-9.997 36.204 0l36.203 36.204c9.997 9.997 9.997 26.206 0 36.204l-294.4 294.401c-9.998 9.997-26.207 9.997-36.204-.001z"></path></svg>
              </span>
              <span class="checkmark"
                    [ngClass]="{'ihsm-multi-option-selected' : selectedItemMulti.length === 0}"></span>
            </div>
          </div>
          <p class="ihsm-display-inline">{{this.data && this.data.customAllOptionsText ? this.data.customAllOptionsText : 'All'}}</p>
          <div *ngIf="data.preCount" class="ihsm-option-count" [ngClass]="selectedItemMulti.length === 0 ? 'selected' : ''">{{formatNumber(data.preCount)}}</div>
        </li>
        <li class="ihsm-multi-links" *ngFor="let option of data?.options" (click)="selectItemMulti($event, option)">
          <div class="checkbox-holder">
            <div class="checkbox">
              <input type="checkbox">
              <span class="ihsm-checkbox-tick" *ngIf="checkSelectedItemMulti(option)">
                <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="check"
                     class="svg-inline--fa fa-check fa-w-16" role="img" xmlns="http://www.w3.org/2000/svg"
                     viewBox="0 0 512 512"><path fill="currentColor"
                                                 d="M173.898 439.404l-166.4-166.4c-9.997-9.997-9.997-26.206 0-36.204l36.203-36.204c9.997-9.998 26.207-9.998 36.204 0L192 312.69 432.095 72.596c9.997-9.997 26.207-9.997 36.204 0l36.203 36.204c9.997 9.997 9.997 26.206 0 36.204l-294.4 294.401c-9.998 9.997-26.207 9.997-36.204-.001z"></path></svg>
              </span>
              <span class="checkmark"
                    [ngClass]="{'ihsm-multi-option-selected' : checkSelectedItemMulti(option)}"></span>
            </div>
          </div>
          <p class="ihsm-display-inline" [ngClass]="!option.count ? 'no-count' : ''" title="{{option.label}}">{{option.label}}</p>
          <div *ngIf="option.count" class="ihsm-option-count" [ngClass]="option.selected ? 'selected' : ''">{{formatNumber(option.count)}}</div>
        <li>
      </ul>

      <div class="ihsm-dropdown-separator"></div>
      <div class="ihsm-dropdown-multi footer">
        <button class="ihsm-btn btn-primary" type="button" (click)="submitSelectedOptions()">
          Apply
        </button>
        <button class="ihsm-btn btn-primary no-outline" type="button" (click)="restoreState()">
          Cancel
        </button>
      </div>
    </div>
  </div>
</div>
